import Header from '../Header/Header.js';
import Footer from '../Footer/Footer.js';
import '../LegalPage/LegalPage.css';
import { Link } from 'react-router-dom';

function CookiesPolicyPage() {
  return (
    <>
      <Header />
      <main className="content">
        <section className="legalPage">
          <div className="legalPage__hero">
            <h2 className="legalPage__title">
              Файлы cookie и технические данные
            </h2>
            <p className="legalPage__lead">
              На этой странице описано, какие технические данные может
              использовать сайт и для чего это необходимо.
            </p>
          </div>

          <div className="legalPage__content">
            <section className="legalPage__section">
              <h3 className="legalPage__section-title">1. Что такое cookie</h3>
              <p className="legalPage__text">
                Cookie и аналогичные технологии браузера позволяют сайту
                запоминать отдельные технические параметры работы и действия
                пользователя. Они не используются на данном сайте для
                маркетингового профилирования или персонализированной рекламы.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                2. Что используется на сайте сейчас
              </h3>
              <ul className="legalPage__list">
                <li className="legalPage__list-item">
                  запись в `localStorage` браузера о принятии уведомления о
                  cookie (`cookieAccepted`);
                </li>
                <li className="legalPage__list-item">
                  технические сведения, автоматически передаваемые при запросе
                  страниц сайта, включая IP-адрес, дату и время обращения,
                  сведения о браузере и запрошенном ресурсе;
                </li>
                <li className="legalPage__list-item">
                  серверные журналы `request.log` и `error.log`, используемые
                  для диагностики и обеспечения стабильной работы сайта.
                </li>
                <li className="legalPage__list-item">
                  сервис Яндекс Метрика, который после согласия пользователя
                  собирает технические и статистические сведения о посещении
                  страниц, источниках переходов, кликах, внешних ссылках и
                  загрузках файлов.
                </li>
              </ul>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                3. Для чего это необходимо
              </h3>
              <ul className="legalPage__list">
                <li className="legalPage__list-item">
                  корректное отображение и функционирование сайта;
                </li>
                <li className="legalPage__list-item">
                  запоминание факта ознакомления пользователя с уведомлением о
                  cookie;
                </li>
                <li className="legalPage__list-item">
                  обеспечение безопасности, диагностика ошибок и техническое
                  администрирование сайта.
                </li>
                <li className="legalPage__list-item">
                  анализ посещаемости и улучшение структуры и содержания сайта.
                </li>
              </ul>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                4. Аналитика и сторонние сервисы
              </h3>
              <p className="legalPage__text">
                Сайт использует сервис Яндекс Метрика только после нажатия
                пользователем кнопки «Принять» в уведомлении. Вебвизор и запись
                сессий не используются. Подробнее о работе сервиса можно узнать
                на{' '}
                <a
                  href="https://yandex.ru/support/metrica/ru/general/how-it-works"
                  className="legalPage__link"
                  target="_blank"
                  rel="noreferrer"
                >
                  странице Яндекс Метрики
                </a>
                .
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                5. Как отказаться от хранения данных в браузере
              </h3>
              <p className="legalPage__text">
                Пользователь может удалить cookie и данные локального хранилища
                через настройки своего браузера. Это может привести к повторному
                отображению уведомления о cookie и необходимости заново
                подтвердить выбор.
              </p>
            </section>

            <section className="legalPage__section">
              <h3 className="legalPage__section-title">
                6. Связь с политикой персональных данных
              </h3>
              <p className="legalPage__text">
                Общая информация об обработке персональных данных размещена на
                странице:{' '}
                <Link to="/privacy-policy/" className="legalPage__link">
                  Политика обработки персональных данных
                </Link>
                .
              </p>
            </section>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
}

export default CookiesPolicyPage;
